import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT } from "../../lib/brand";
import { SERVICES } from "../../data/services";
import { MountainMark } from "./Marks";

const Col = ({ title, children }) => (
  <div>
    <h4 className="font-body text-xs uppercase tracking-[0.22em] text-summit-gold-light mb-5">{title}</h4>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const FLink = ({ to, children, testId }) => (
  <li>
    <Link to={to} data-testid={testId} className="font-body text-sm text-white/70 hover:text-white transition-colors">
      {children}
    </Link>
  </li>
);

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-summit-forest text-white pt-20 pb-10 overflow-hidden grain">
    <div className="relative max-w-7xl mx-auto px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <MountainMark className="w-14 h-7" id="footer-mark" />
            <span className="font-heading text-2xl font-semibold tracking-tight">Summit Transformation Group</span>
          </div>
          <p className="font-heading text-2xl md:text-3xl font-light leading-snug text-white/90 max-w-md">
            Where AI Strategy Meets Organizational Transformation.
          </p>
          <p className="mt-5 font-body text-sm text-white/60 leading-relaxed max-w-md">
            An executive-level advisory firm helping organizations adopt AI and lead complex transformation.
          </p>
          <a
            href={CONTACT.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            className="mt-6 inline-flex items-center gap-2 font-body text-sm text-white/70 hover:text-summit-gold-light transition-colors"
          >
            <Linkedin size={18} /> Connect on LinkedIn
          </a>
        </div>

        <div className="md:col-span-3">
          <Col title="Services">
            {SERVICES.map((s) => (
              <FLink key={s.slug} to={`/services/${s.slug}`} testId={`footer-service-${s.slug}`}>{s.navLabel}</FLink>
            ))}
          </Col>
        </div>

        <div className="md:col-span-2">
          <Col title="Firm">
            <FLink to="/about" testId="footer-link-about">About</FLink>
            <FLink to="/insights" testId="footer-link-insights">Insights</FLink>
            <FLink to="/contact" testId="footer-link-contact">Contact</FLink>
          </Col>
        </div>

        <div className="md:col-span-3">
          <Col title="Contact">
            <li className="flex items-start gap-2 font-body text-sm text-white/70"><Mail size={15} className="mt-0.5 shrink-0" /><a href={`mailto:${CONTACT.email}`} className="hover:text-white break-words">{CONTACT.email}</a></li>
            <li className="flex items-start gap-2 font-body text-sm text-white/70"><Phone size={15} className="mt-0.5 shrink-0" />{CONTACT.phone}</li>
            <li className="flex items-start gap-2 font-body text-sm text-white/70"><MapPin size={15} className="mt-0.5 shrink-0" />{CONTACT.location}</li>
          </Col>
        </div>
      </div>

      <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4">
        <p className="font-body text-xs text-white/45">© {new Date().getFullYear()} Summit Transformation Group. All rights reserved.</p>
        <p className="font-body text-xs text-white/45">Summit Transformation Framework™ is a trademark of Summit Transformation Group.</p>
      </div>
    </div>
  </footer>
);
